module.exports = __webpack_public_path__ + "f84300637491d552ae16276d98d5de47.MP3";